import { Row } from 'antd';
import styled from 'styled-components';

export const FilterArea = styled.div`
    padding: 20px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .ant-form-item .ant-row {
        margin: 0px !important;
    }
`;

export const FilterHeader = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
    padding-left: 2px;
`;

export const FilterTitle = styled.h2`
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 20px;
    margin: 0px;
`;

export const RowStyled = styled(Row)`
    margin: 0px !important;
`;

export const Actions = styled.div<{ $align: 'left' | 'right' }>`
    display: flex;
    justify-content: ${({ $align }) =>
        $align === 'left' ? 'flex-start' : 'flex-end'};
    align-items: center;
    width: 100%;
`;
